export default __webpack_public_path__ + "9ff186ed7eb7788beafaef982fcd5170.svg";